var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from '@mui/material';
import { DefaultCard } from '../../../../components/DefaultCard';
import { TipoImovelEnum } from '../../../../model/enums/TipoImovelEnum';
import { CustomRadioGroup } from '../../../../components/Forms/CustomRadioGroup';
import React from 'react';
export var DadosTipoImovelParcela = function (_a) {
    var _b;
    var onChange = _a.onChange, parcelaImovel = _a.parcelaImovel, onChangeTipoImovel = _a.onChangeTipoImovel;
    var handleChange = function (value) {
        onChange(value);
        onChangeTipoImovel === null || onChangeTipoImovel === void 0 ? void 0 : onChangeTipoImovel(value);
    };
    return (_jsx(DefaultCard, __assign({ title: '' }, { children: _jsx(Grid, __assign({ container: true, style: { padding: '15px' } }, { children: _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(CustomRadioGroup, { onChange: function (event) { return handleChange(event.target.value); }, value: (_b = parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.tipoImovel) !== null && _b !== void 0 ? _b : TipoImovelEnum.URBANO, options: TipoImovelEnum.getOptions(), label: "Tipo do Im\u00F3vel ?", name: "tipoOcupante", required: true, collumn: true }) })) })) })));
};
